var map = {
	"./face-detector-screenshot.png": "9b6d",
	"./logo_transparent-no-text.png": "fc53",
	"./my-team-screenshot.png": "d48b",
	"./portfolio-screenshot.png": "715b",
	"./portrait-small.png": "af50"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "1771";